import { createAuthClient } from "better-auth/react";
import { jwtClient } from "better-auth/client/plugins";

// VX sign-in (Better Auth) hosted by the VX admin at admin.dcams.app.
export const AUTH_URL =
  process.env.REACT_APP_VX_AUTH_URL || "https://admin.dcams.app/api/auth";

// The admin origin is the auth URL without the /api/auth suffix.
export const ADMIN_ORIGIN = AUTH_URL.replace(/\/api\/auth\/?$/, "");

export const authClient = createAuthClient({
  baseURL: AUTH_URL,
  plugins: [jwtClient()],
});

// Where to send someone who has no session (or whose session was rejected).
export function signInUrl(returnTo = window.location.href) {
  return `${ADMIN_ORIGIN}/login?returnTo=${encodeURIComponent(returnTo)}`;
}

export function redirectToSignIn() {
  window.location.assign(signInUrl());
}

export async function signOut() {
  try {
    await authClient.signOut();
  } finally {
    window.location.assign(signInUrl(window.location.origin));
  }
}
